import * as React from "react"
import Body from "../../../atoms/typography/Body"
import YellowGradientLine from "../../../atoms/YellowGradientLine"
import { Variant } from "../../../interfaces/SaleorTypes"
import { getFormattedPrice } from "../../../../utils/cart-helpers"
import { HorizontalSpacer } from "../../../atoms/spacers"
import styled from "styled-components"
import H3 from "../../../atoms/typography/H3"
import { Row } from "react-grid-system"

interface Props {
  amountOfRentals: number
  rentalTerminalInitialFeePrice: number
  rentalMonthlyFeePrice: number
  numberOfMonths: number
  chosenDataPackage: Variant
  chosenDataPackagePrice: number
  currency: string
  selectedDate: string
  subTotal: number
}

const ImageContainer = styled.img`
  width: 56px;
  height: 60px;
  object-fit: contain;
`

const TitleSection = styled.div`
  display: flex;
  align-items: center;
`

const RentalPriceBreakdown: React.FC<Props> = ({
  amountOfRentals,
  rentalTerminalInitialFeePrice,
  rentalMonthlyFeePrice,
  numberOfMonths,
  chosenDataPackage,
  chosenDataPackagePrice,
  currency,
  selectedDate,
  subTotal,
}) => {
  return (
    <div>
      <HorizontalSpacer spacing={1.5} />
      <Row justify="between" align="center" nogutter>
        <H3>Start cost</H3>
      </Row>
      <HorizontalSpacer spacing={0.5} />
      <Row justify="between" align="center" nogutter>
        <Body>Price:</Body>
        <Body>{getFormattedPrice(rentalTerminalInitialFeePrice, currency)}</Body>
      </Row>

      <HorizontalSpacer spacing={1.5} />
      <Row justify="between" align="center" nogutter>
        <H3>Rental duration:</H3>
        <H3>{numberOfMonths} months</H3>
      </Row>
      <HorizontalSpacer spacing={0.5} />
      <Row justify="between" align="center" nogutter>
        <Body>Price:</Body>
        <Body>{getFormattedPrice(rentalMonthlyFeePrice, currency)}</Body>
      </Row>

      <HorizontalSpacer spacing={1.5} />
      <Row justify="between" align="center" nogutter>
        <H3>Data package:</H3>
        <H3>{chosenDataPackage.name}</H3>
      </Row>
      <HorizontalSpacer spacing={0.5} />
      <Row justify="between" align="center" nogutter>
        <Body>Price:</Body>
        <Body>{getFormattedPrice(chosenDataPackagePrice, currency)}</Body>
      </Row>

      <HorizontalSpacer spacing={1.5} />
      <Row justify="between" align="center" nogutter>
        <H3>Shipping & return:</H3>
        <H3>DHL</H3>
      </Row>
      <HorizontalSpacer spacing={0.5} />
      <Row justify="between" align="center" nogutter>
        <Body>Price:</Body>
        <Body>Free</Body>
      </Row>
      <HorizontalSpacer spacing={1.5} />
      <YellowGradientLine />

      <HorizontalSpacer spacing={3} />
      <Row justify="between" align="center" nogutter>
        <H3>Price per package:</H3>
        <H3>{getFormattedPrice(subTotal, currency)}</H3>
      </Row>
      <HorizontalSpacer spacing={1.5} />
      <Row justify="between" align="center" nogutter>
        <H3>Amount of packages:</H3>
        <H3>{amountOfRentals}</H3>
      </Row>

      <HorizontalSpacer spacing={1.5} />
      <Row justify="between" align="center" nogutter>
        <H3>Preliminary start date:</H3>
        <H3>{selectedDate}</H3>
      </Row>
      <HorizontalSpacer spacing={2} />
      <H3 textAlign="center">Estimated delivery date:</H3>
      <H3 textAlign="center">In 3 business days or {selectedDate}</H3>
    </div>
  )
}

export default RentalPriceBreakdown
